/**
 * Role names, kept in one place so a check never drifts from the API's own
 * list (see User::ROLES on the Laravel side).
 */
export const ROLE_USER = 'user';
export const ROLE_PHOTOGRAPHER = 'photographer';
export const ROLE_EVENT_MANAGER = 'event_manager';

/**
 * Photographers and event managers both own events, create them and upload to
 * them. Almost every "is this a photographer?" check in the app really meant
 * this, so prefer it over comparing to ROLE_PHOTOGRAPHER directly.
 */
export const ownsEvents = (user) =>
  user?.role === ROLE_PHOTOGRAPHER || user?.role === ROLE_EVENT_MANAGER;

export const isEventManager = (user) => user?.role === ROLE_EVENT_MANAGER;

export const isPhotographer = (user) => user?.role === ROLE_PHOTOGRAPHER;

/** Label for the role, for display. */
export const roleLabel = (role) =>
  ({
    [ROLE_USER]: 'Utilisateur',
    [ROLE_PHOTOGRAPHER]: 'Photographe',
    [ROLE_EVENT_MANAGER]: "Organisateur d'événements",
  }[role] || role);
